import ProductItem from "./ProductItem";
import React from "react";
import { useTranslation } from "react-i18next";

const RelatedProducts = ({ items }) => {
  const { t } = useTranslation();
  return (
    <div className="related-products-section-holder">
      <div className="section-title">
        <h2>{t("other.relatedProducts")}</h2>
      </div>
      <div className="related-products-section-content">
        <div className="products-content-main">
          {items?.map((item, key) => (
            <ProductItem item={item} key={key} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RelatedProducts;
